// import external dependencies
// Import everything from partials
// import 'js/**'




// Webpack Imports
import $ from 'jquery';
import * as bootstrap from 'bootstrap';
window.jQuery = window.$ = $; 

// barba.init({
//   transitions: [{
//       name: 'default-transition',
//       leave(data) {
//           return gsap.to(data.current.container, {
//               duration: 0.5,
//               y: 200,
//               opacity: 0,
//           });
//       },
//       after(data) {
//           return gsap.from(data.next.container, {
//               duration: 0.5,
//               y: 200,
//               opacity: 0,
//               onComplete: function() {
//                 initScrollTriggers();
//               }
//           });
//       }
//   }]
// });

// barba.hooks.afterLeave((data) => {
//   let triggers = ScrollTrigger.getAll();
//   triggers.forEach( trigger => { 
//     trigger.kill();
//   });
// });

// barba.hooks.enter((data) => {
// window.scrollTo(0, 0);
// ScrollTrigger.refresh(true);
// });

// barba.hooks.afterEnter((data) => {
// // console.log(data.next.namespace);
// // var x = data.next.namespace;
// reInitialized();
// });





( function () {
	'use strict';
  // initialize tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  
  //add tooltip to zipcode field
//   $('div.tooltip-zip label').attr({
//     'data-bs-placement':'top',
//     'data-bs-toggle':'tooltip',
//     'data-bs-title': 'Enter your organization\'s zip code to be routed to your local Snap! Mobile rep.' // attributes which contain dash(-) should be covered in quotes.
// });

	// Focus input if Searchform is empty
	// [].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
	// 	el.addEventListener( 'submit', function ( e ) {
	// 		var search = el.querySelector( 'input' );
	// 		if ( search.value.length < 1 ) {
	// 			e.preventDefault();
	// 			search.focus();
	// 		}
	// 	} );
	// } );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

// SCROLL FADE IN REVEAL 

var scroll = window.requestAnimationFrame ||
             // IE Fallback
             function(callback){ window.setTimeout(callback, 1000/60)};
var elementsToShow = document.querySelectorAll('.reveal'); 

function loop() {

    Array.prototype.forEach.call(elementsToShow, function(element){
      if (isElementInViewport(element)) {
        element.classList.add('is-visible');
      } else {
        element.classList.remove('is-visible');
      }
    });

    scroll(loop);
}

// Call the loop for the first time
loop();

function isElementInViewport(el) {
  // special bonus for those using jQuery
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();
  return (
    (rect.top <= 0
      && rect.bottom >= 0)
    ||
    (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight))
    ||
    (rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
  );
}


//SLICK SLIDER
  $(function () {
    
    'use strict';

    //TESTIMONIAL SLIDER
  
    if($(".testimonial-slider").length) {
            
      $(function() {
        
          $('.testimonial-slider').slick({
              vertical: true,
              lazyLoad: 'ondemand',
              verticalSwiping: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              arrows: true,
              infinite: true,
              prevArrow: '<div class="slick-prev"></div>',
              nextArrow: '<div class="slick-next"></div>',
              dots: true,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                  vertical: false,
                  verticalSwiping: false
                  }

                },
                
              ]
          });
      });
  }
      

      if($(".testimonial-partner-slider").length) {
        $(function() {
          $('.testimonial-partner-slider').slick({
             slidesToShow: 1,
             slidesToScroll: 1,
             autoplay: false,
             arrows: true,
             infinite: true,
             prevArrow: '<div class="slick-prev"></div>',
             nextArrow: '<div class="slick-next"></div>',
             dots: false,
             
            
          });
  
        });
      }

      
      if($(".custom-posts-slider").length) {
        $(function() {
          $('.custom-posts-slider').slick({
            arrows: true,
            infinity: true,
            slidesToShow: 3,
            prevArrow: '<div class="slick-prev"></div>',
            nextArrow: '<div class="slick-next"></div>',
            responsive: [
              {
                breakpoint: 900,
                settings: {
                  arrows: true,
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 600,
                settings: {
                  arrows: true,
                  slidesToShow: 1
                }
              }
            ]
          });


        });
  
      }
     
      if($(".section-logo-slider").length) {
        $(function() {
          $('.image-logo-slider').slick({
            autoplay: true,
            autoplaySpeed: 6000,
            cssEase: 'linear',
            speed: 500,
            arrows: true,
            dots: false,
            infinity: true,
            waitForAnimate: false,
            pauseOnFocus: false, 
            pauseOnHover: false,
            slidesToShow: 5,
            prevArrow: '<div class="slick-prev"></div>',
            nextArrow: '<div class="slick-next d-none"></div>',
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  autoplay: true,
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 768,
                settings: {
                  autoplay: true,
                  slidesToShow: 1,
                }
              }
            ]
          });

   
          });
  
    }



     if($(".featured-logo-slider").length) {
      $(function() {
        $('.featured-logo-slider').slick({
          // centerMode: true,
          // centerPadding: '60px',
          infinity: true,
          slidesToShow: 6,
          prevArrow: '<div class="slick-prev"></div>',
          nextArrow: '<div class="slick-next"></div>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: false,
                // centerPadding: '40px',
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                // centerMode: true,
                // centerPadding: '40px',
                slidesToShow: 1
              }
            }
          ]
        });


      });

     }
  });

  //mousescroll nav for testimonials
//   const slider = $(".testimonial-slider");

// slider.on('wheel', (function(e) {
//   e.preventDefault();

//   if (e.originalEvent.deltaY < 0) {
//     $(this).slick('slickNext');
//   } else {
//     $(this).slick('slickPrev');
//   }
// }));

/******* SEARCH OVERLAY **********/

$(function () {
    $('a[href="#searchbox"]').on('click', function(event) {
        event.preventDefault();
        $('#searchbox').addClass('open');
        $(document.body).addClass('no-scroll');
        $('#searchbox > form > input[type="search"]').focus();
    });
    
    $('#searchbox, #searchbox button.close').on('click keyup', function(event) {
        if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
            $(this).removeClass('open');
            $("body").removeClass("no-scroll");
        }
    });
    
});


// TOP NAV ANIMATION
const showAnim = gsap.from('.the-header', { 
  yPercent: -135,
  paused: true,
  duration: 0.2
}).progress(1);

ScrollTrigger.create({
  start: "top top",
  end: 99999,
  onUpdate: (self) => {
    self.direction === -1 ? showAnim.play() : showAnim.reverse()
  }
});





// If class show vertical scroller  
// if (jQuery('.section-scroller').length > 0) 
//    { 
//       //If the element exist, then do something.
//       vertScroll();
//       // add_scroller_js();
//    }

// function vertScroll(){
//  gsap.registerPlugin(ScrollTrigger);

//  let sections = gsap.utils.toArray(".panel");
 
//  gsap.to(sections, {
//    xPercent: -100 * (sections.length - 1),
//    ease: "none",
//    scrollTrigger: {
//      trigger: ".section-scroller",
//      pin: true,
//      scrub: 1,
//      snap: 1 / (sections.length - 1),
//      // base vertical scrolling on how wide the container is so it feels more natural.
//      end: "+=3500",
//    }
//  });
// }

// GET HEADER HEIGHT TO ADD BODY PADDING
// $(window).on("load resize", function (event) {
//   var $navbar = $(".the-header");
//   var $content = $("#main");

//   $content.css("padding-top", $navbar.outerHeight());
// });
   
/*

***************SEARCH*******************

*/
jQuery(function () {
  $('a[href="#search"]').on('click', function(event) {
      event.preventDefault();
      $('#search').addClass('open');
      $('#search > form > input[type="search"]').focus();
  });
  
  jQuery('#search, #search button.close').on('click keyup', function(event) {
      if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
          $(this).removeClass('open');
      }
  });
});



/******* MASONRY change is-checked class on buttons **********/ 

jQuery(function () {

  

  if($("#grid").length) {
  $("#grid").masonry({ 
    itemSelector: ".grid-item",
    percentPosition: true,
    columnWidth: '.col-lg-4',
    // gutter: 20,
  });
  
  $(".filtering").on("click", "span", function () {
      var a = $("#grid").isotope({});
      var e = $(this).attr("data-filter");
      a.isotope({ filter: e });
  });
  $(".filtering").on("click", "span", function () {
      $(this).addClass("active").siblings().removeClass("active");
  });

  // arrow animations

let arrow = document.querySelector('.arrow');
let arrowRight = document.querySelector('.arrow-right');

if(arrow){
  gsap.to(arrow, {y: 12, ease: "power1.inOut", repeat: -1, yoyo: true});
}

if(arrowRight){
  gsap.to(arrowRight, {x: -12, ease: "power1.inOut", repeat: -1, yoyo: true});
}

}


})


/****************************SMOOTH SCROLL ANCHOR****************************/

jQuery(function () {

  $("a").on('click', function(event) {
    if (this.hash !== "") {
      var hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function() {

        window.location.hash = hash;
      });
      return false;
    } 
  });
});


$(window).on("load", function () {

  var urlHash = window.location.href.split("#")[1];
  if (urlHash &&  $('#' + urlHash).length )
        $('html, body').animate({
            scrollTop: $('#' + urlHash).offset().top
        }, 800);
});


// IF SUBNAV EXISTS ADD CLASS TO BODY
var hasSubnav = document.getElementsByClassName('subnav');
if (hasSubnav.length > 0) {
  $('#main').addClass('hassubnav main-content');
}


var leadGen = document.getElementById('gform_wrapper_23');
if (leadGen) {
gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {

  if ( formId ==23 && fieldId == 76 ) {
    optionsObj.minDate = 0+1;
  }
  return optionsObj;
});

}

